import axios, { AxiosRequestConfig } from 'axios';
import { PagedResponse } from '../types/api';
import { SampleVideo } from '../types/SampleVideo';

const URL = '/v2/sample-videos';

class SampleVideoService {
  static getByFilter(
    config?: AxiosRequestConfig,
  ): Promise<PagedResponse<SampleVideo>> {
    return axios.get(URL, config);
  }
}

export { SampleVideoService };
